var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModuleContainer",
    _vm._b(
      {
        attrs: { position: _vm.position },
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                !_vm.measurement_type
                  ? _c(
                      "MapControlGroupButton",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.tools.distance"
                              ),
                              active: _vm.measurement_type == "distance",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onMeasureDistance()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.distance,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.tools.area"
                              ),
                              active: _vm.measurement_type == "area",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onMeasureArea()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.area,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.tools.azimuth"
                              ),
                              active: _vm.measurement_type == "azimuth",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onMeasureAzimuth()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.azimuth,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.tools.point"
                              ),
                              active: _vm.measurement_type == "point",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onMeasureMarker()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.point,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "MapControlGroupButton",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.action.add"
                              ),
                              disabled:
                                !_vm.coordinates || _vm.coordinates.length < 1,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addToLayerControl()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.add,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.action.setting"
                              ),
                              active: _vm.setting.show,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSetting()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.setting,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              disabled:
                                !_vm.coordinates || _vm.coordinates.length < 1,
                              tooltip: _vm.$map.trans(
                                "map.measurement.action.fly-to"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onFlyTo()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.fillBound,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.action.clear"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.reset()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.clear,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "MapControlButton",
                          {
                            attrs: {
                              tooltip: _vm.$map.trans(
                                "map.measurement.action.close"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.clear()
                              },
                            },
                          },
                          [
                            _c("SvgIcon", {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _vm.path.close,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default"),
      _c("MeasurementSettingPopup", {
        attrs: {
          show: !!_vm.measurement_type && _vm.setting.show,
          position: _vm.position,
          maxLength: _vm.setting.maxLength,
          fields: _vm.setting.fields,
        },
        on: {
          "update:show": function ($event) {
            _vm.setting.show = $event
          },
          input: _vm.setValue,
        },
        model: {
          value: _vm.coordinates,
          callback: function ($$v) {
            _vm.coordinates = $$v
          },
          expression: "coordinates",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }